import { ELayoutType } from '../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectLayoutFilter } from 'shared/selectors/advancedFilters';
import { WithLayoutContainer } from '../WithLayoutContainer';
import { SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';

export const LayoutContainer: FC = () => {
  const { label, value, options, visible } = useSelector(selectLayoutFilter);

  const onChange = useFilterChangeCallback();

  const handleLayoutTypeChange = useCallback(
    (newValue: ELayoutType | null) => {
      onChange({ action: 'setLayoutType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        {visible && (
          <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleLayoutTypeChange} />
        )}

        <InlineFilter>
          <WithLayoutContainer />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
